module.exports = __webpack_public_path__ + "img/uploadfile.a56fd190.svg";